import { Component, OnInit, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { VERSION } from 'src/environments/environment';

@Component({
  selector: 'app-changelog',
  templateUrl: './changelog.component.html',
  styleUrls: ['./changelog.component.scss'],
  standalone: false,
})
export class ChangelogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<ChangelogComponent>>(MatDialogRef);

  public noMostrar = true;

  ngOnInit(): void {}

  public cerrar() {
    if (this.noMostrar) {
      localStorage.setItem(`changelog-${VERSION}`, '1');
    }
    this.dialogRef.close();
  }
}
